import PropTypes from 'prop-types';
import React from 'react';

import Overlay from './Overlay';

/**
* -Overlays-
* Overlays component
**/
export default class Overlays extends React.Component {

	state = {
		overlays: []
	}

	updateOverlays = () => {

		// Combine overlays to array (if object)
		let overlays;

		if (!Array.isArray(this.props.overlays)) {

			overlays = Object
				.keys(this.props.overlays)
				.map((key) => this.props.overlays[key]);
			overlays = [].concat(...overlays);

		} else {

			overlays = this.props.overlays;
		}

		overlays = (overlays === undefined) ? [] : overlays;

		this.setState({ overlays: overlays });
	}

	componentDidMount() {

		this.updateOverlays();
	}

	componentDidUpdate(prevProps) {

		if (this.props.overlays !== prevProps.overlays) {

			this.setState({ overlays: [] }, () => {

				this.updateOverlays();
			});
		}
	}

	render() {

		const overlays = this.state.overlays.map((overlay, i) =>
			<Overlay
				content={ overlay.content }
				visible={ overlay.visible }
				marker={ overlay.marker }
				position={ overlay.position }
				title={ overlay.title }
				onRoad={ overlay.onRoad }
				routeNo={ overlay.routeNo }
				routeColor={ overlay.color }
				routeArea={ overlay.routeArea }
				key={ i }
				{ ...this.props }
			/>
		);

		return (
			<div>
				{ overlays }
			</div>
		)
	}
}

Overlays.propTypes = {
	overlays: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	]),
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Overlays.js